import React from 'react';
import classnames from 'classnames';

import {
  COMMON_FORM_FIELD_CLASSES,
  FORM_FIELD_VARIANT_TYPES
} from 'dpl/shared/form/utils/constants';

import Label from './Label';
import ErrorWrapper from './ErrorWrapper';

export const VARIANT_CLASSES: Record<string, string> = {
  [FORM_FIELD_VARIANT_TYPES.LARGE]: `${COMMON_FORM_FIELD_CLASSES} Textarea__input h4 pv4 ph4 fw-medium`,
  [FORM_FIELD_VARIANT_TYPES.REGULAR]: `${COMMON_FORM_FIELD_CLASSES} Textarea__input h4 pv2 ph2`
};

interface SimpleTextareaProps extends Record<string, any> {
  displayErrors?: boolean;
  errors?: React.ReactNode[];
  id?: string | null;
  label?: string | null;
  labelProps?: { className?: string };
  maxCharCount?: number | null;
  name: string;
  noResize?: boolean;
  onChange?: ((e: React.ChangeEvent<HTMLTextAreaElement>) => void) | null;
  value?: string | null;
  newDesignSystemStyles?: boolean;
  placeholder?: string | null;
  variant?: string;
}

export default function SimpleTextarea({
  displayErrors = false,
  errors = [],
  id = null,
  label = null,
  labelProps = {},
  maxCharCount = null,
  name,
  noResize = false,
  onChange = null,
  value = null,
  placeholder = null,
  variant = FORM_FIELD_VARIANT_TYPES.REGULAR,
  newDesignSystemStyles = false,
  ...textareaProps
}: SimpleTextareaProps) {
  const classes = classnames(VARIANT_CLASSES[variant], {
    'no-resize': noResize,
    'ph4 pv3 font-16 lh-body': newDesignSystemStyles
  });

  const textareaValue = value || '';
  const charCount = maxCharCount ? maxCharCount - textareaValue.length : 0;

  return (
    <div className="Textarea">
      {(() => {
        if (label && maxCharCount) {
          return (
            <div className="flex justify-between">
              <Label
                htmlFor={id}
                text={label}
                newDesignSystemStyles={newDesignSystemStyles}
                {...labelProps}
              />
              <p
                className={classnames('f2 self-center', {
                  'light-silver': charCount >= 0,
                  red: charCount < 0
                })}
              >
                {charCount}
              </p>
            </div>
          );
        } else if (label) {
          return (
            <Label
              htmlFor={id}
              text={label}
              newDesignSystemStyles={newDesignSystemStyles}
              {...labelProps}
            />
          );
        }

        return null;
      })()}
      <ErrorWrapper isShown={displayErrors} errors={errors}>
        <textarea
          className={classes}
          id={id ?? undefined}
          name={name}
          onChange={onChange ?? undefined}
          placeholder={placeholder ?? undefined}
          value={textareaValue}
          {...textareaProps}
        />
      </ErrorWrapper>
    </div>
  );
}
